// Resuelve el id de emisor/receptor de un comprobante (voucher.emitter, spent.receiver)
// o de una cuenta monetaria (money_account.emitter). Devuelve null para los
// pseudo-comprobantes "a cuenta" (id 0) y para objetos sin emisor asociado.
function emitterIdOf(obj) {
  if (obj == null) return null;
  if (obj.id == 0) return null;
  const emitter = obj.emitter != null ? obj.emitter : obj.receiver;
  return emitter != null ? emitter.id : null;
}

// Recorre `list` tomando de cada elemento la propiedad `key` (ej. "voucher", "spent",
// "money_account") y devuelve el primer id de emisor resoluble, o null si ninguno lo tiene.
function firstEmitterIdIn(list, key) {
  if (list == null) return null;
  for (const item of list) {
    const id = emitterIdOf(item[key]);
    if (id != null) return id;
  }
  return null;
}

// Devuelve el emisor "ancla" de una cobranza/pago: el primero resoluble entre los candidatos,
// evaluados en orden de prioridad. Cada candidato es { list, key } (busca en una coleccion)
// o { emitter } (un emisor/receptor directo, ej. item.receiver en pagos).
// Devuelve null mientras no haya ningun emisor definido, es decir, mientras se pueda
// elegir libremente comprobantes y formas de cobro/pago de cualquier emisor.
function anchorEmitterId(candidates) {
  if (candidates == null) return null;
  for (const candidate of candidates) {
    var id = null;
    if (candidate.list !== undefined) id = firstEmitterIdIn(candidate.list, candidate.key);
    else if (candidate.emitter != null) id = candidate.emitter.id;
    if (id != null) return id;
  }
  return null;
}

export const emitterUtils = {
  emitterIdOf,
  firstEmitterIdIn,
  anchorEmitterId,
};
